import { textblockTypeInputRule } from 'prosemirror-inputrules';
import { Command } from 'prosemirror-state';

import { EditorOptions, localStorage } from '@lyearn/lygo-core';

import CodeFence from '../CodeFence';
import {
  insertSpaceTab,
  moveToNextNewline,
  moveToPreviousNewline,
  newlineInCode,
} from './commands';
import { CODE_BLOCK_REGEX, DEFAULT_LANGUAGE, NODE_NAME, PERSISTENCE_KEY } from './consts';
import plugins from './plugins';

export default class CodeBlock extends CodeFence {
  get name(): string {
    return NODE_NAME;
  }

  get keys(): { [key: string]: Command } | null {
    return {
      Tab: insertSpaceTab,
      Enter: newlineInCode,
      'Ctrl-a': moveToPreviousNewline,
      'Ctrl-e': moveToNextNewline,
    };
  }

  inputRules = ({ schema }: EditorOptions) => {
    return [
      textblockTypeInputRule(CODE_BLOCK_REGEX, schema.nodes.code_block, () => ({
        language: localStorage.get(PERSISTENCE_KEY, DEFAULT_LANGUAGE),
      })),
    ];
  };

  get markdownToken() {
    return NODE_NAME;
  }

  plugins = plugins;
}
